export type BgpFileInfo = {
  content: string;
  replaceEntries?: boolean;
};

export const bgpFileHeaders = [
  'Serial number',
  'Protocol',
  'VRF name',
  'Use native VRF name',
  'List of communities',
] as const;

export type BgpFileHeader = (typeof bgpFileHeaders)[number];

export function isBgpFileHeader(value: string): value is BgpFileHeader {
  return bgpFileHeaders.includes(value as BgpFileHeader);
}

const nativeVrfLabels = ['yes', 'no'] as const;
type NativeVrf = (typeof nativeVrfLabels)[number];

export function isNativeVrf(value: string): value is NativeVrf {
  return nativeVrfLabels.includes(value as NativeVrf);
}

export const bgpProtocols = ['IPv4', 'IPv6'] as const;

export type BgpProtocol = (typeof bgpProtocols)[number];

export function isBgpProtocol(value: unknown): value is BgpProtocol {
  return bgpProtocols.includes(value as BgpProtocol);
}
